import styles from "./styles.module.scss";
import { ProductTable } from "../ProductTable";

export const ProductSelection = ({
  billsForm,
  setBillsForm = () => {},
  ...validationParams
}) => {
  return (
    <div className={styles.productSelection}>
      <ProductTable
        billsForm={billsForm}
        setBillsForm={setBillsForm}
        {...validationParams}
      />
    </div>
  );
};
